import { apolloProvider as myStageApolloProvider } from '@/modules/myStageGraphQL';
import { GET_MYSTAGE_DEV_TEST_LESSON_TOKEN } from '@/graphql/mystageLessonToken';
import logger from '@/modules/Logger';

/**
 * Endpoint for Admin Dev Test Token
 * This is only applicable on MSB endpoint
 */
export const GetAdminDevTestTokenService = {
  msb: async (params) => {
    logger.debug(`[Admin Dev Test] Fetch lesson token from MSB GraphQL endpoint`, {
      operation: 'get:admin-dev-test'
    }
    );

    try {
      const client = myStageApolloProvider.defaultClient;
      const { data } = await client.query({
        query: GET_MYSTAGE_DEV_TEST_LESSON_TOKEN,
        fetchPolicy: 'no-cache',
        variables: {
          input: { ...params }
        }
      });

      if (data?.mystageDevTestLesson?.token) {
        return data.mystageDevTestLesson.token;
      } else {
        logger.error(`[GetAdminDevTestTokenService] Mystage Lesson Token request failed: No token data found`, {
          operation: 'get:admin-dev-test'
        });
      }
    } catch (error) {
      let message = error.message;
      logger.error(`[GetAdminDevTestTokenService] Mystage Lesson Token request failed: ${message}`, {
        operation: 'get:admin-dev-test'
      });
    }
  }
};
